import moment from "moment";
import React from "react";
import type { IFuneralDetail } from "service/interface/funeral";

interface Props {
  data: IFuneralDetail;
  setData: React.Dispatch<React.SetStateAction<IFuneralDetail>>;
}

export function AccountInfoTable({ data, setData }: Props) {
  const handleStatusBtn = (status: boolean) => {
    setData((prev) => ({
      ...prev,
      status: status ? 1 : 0,
    }));
  };

  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          계정 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            이름
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            {data.name}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            처리 상태
          </div>
          <div className="flex h-full w-[303px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
            <label
              className="flex cursor-pointer items-center gap-[8px]"
              htmlFor="falseStatus"
            >
              <input
                type="radio"
                id="falseStatus"
                checked={data.status === 0 ? true : false}
                onChange={() => handleStatusBtn(false)}
                className="m-0 cursor-pointer text-blue-1 focus:ring-0 focus:ring-white"
              />
              <p className="m-0 text-M3 text-gray-5">미처리</p>
            </label>
            <label
              className="flex cursor-pointer items-center gap-[8px]"
              htmlFor="trueStatus"
            >
              <input
                type="radio"
                id="trueStatus"
                checked={data.status === 0 ? false : true}
                onChange={() => handleStatusBtn(true)}
                className="m-0 cursor-pointer text-blue-1 focus:ring-0 focus:ring-white"
              />
              <p className="m-0 text-M3 text-gray-5">처리 완료</p>
            </label>
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            휴대폰 번호
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            {data.phone}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            회원 구분
          </div>
          <div className="flex h-full w-[303px] items-center px-[12px] text-M3 text-gray-5">
            {data.UserId ? "회원" : "비회원"}
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            연락 가능한 시간
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            {data.possibleContactTime}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            신청 일자
          </div>
          <div className="flex h-full w-[303px] items-center px-[12px] text-M3 text-gray-5">
            {moment(data.createdAt).format("YYYY-MM-DD")}
          </div>
        </div>
      </div>
    </div>
  );
}
